module.exports = __webpack_public_path__ + "static/media/icon-atraso.a3a18aa1.svg";